export const convertUrlToFile = async (url: string, filename: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], `${filename}`, { type: blob.type });
  } catch (err) {
    return null;
  }
};
